// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../font/zintunes.eot?64742434", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../font/zintunes.woff2?64742434", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../font/zintunes.woff?64742434", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../font/zintunes.ttf?64742434", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../font/zintunes.svg?64742434", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___, { hash: "#zintunes" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
@font-face {
  font-family: "zintunes";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
/* Chrome hack: SVG is rendered more smooth in Windozze. 100% magic, uncomment if you need it. */
/* Note, that will break hinting! In other OS-es font will be not as sharp as it could be */
/*
@media screen and (-webkit-min-device-pixel-ratio:0) {
  @font-face {
    font-family: 'zintunes';
    src: url('../font/zintunes.svg?64742434#zintunes') format('svg');
  }
}
*/
[class^=icon-]:before, [class*=" icon-"]:before {
  font-family: "zintunes";
  font-style: normal;
  font-weight: normal;
  speak: never;
  display: inline-block;
  text-decoration: inherit;
  width: 1em;
  margin-right: 0.2em;
  text-align: center;
  /* opacity: .8; */
  /* For safety - reset parent styles, that can break glyph codes*/
  font-feature-settings: normal;
  font-variant: normal;
  text-transform: none;
  /* fix buttons height, for twitter bootstrap */
  line-height: 1em;
  /* Animation center compensation - margins should be symmetric */
  /* remove if not needed */
  margin-left: 0.2em;
  /* you can be more comfortable with increased icons size */
  /* font-size: 120%; */
  /* Font smoothing. That was taken from TWBS */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* Uncomment for 3D effect */
  /* text-shadow: 1px 1px 1px rgba(127, 127, 127, 0.3); */
}

.icon-album:before {
  content: "\\e800";
} /* '' */
.icon-anchor:before {
  content: "\\e801";
} /* '' */
.icon-caret-down:before {
  content: "\\e802";
} /* '' */
.icon-check-circle:before {
  content: "\\e803";
} /* '' */
.icon-check:before {
  content: "\\e804";
} /* '' */
.icon-close:before {
  content: "\\e805";
} /* '' */
.icon-delete:before {
  content: "\\e806";
} /* '' */
.icon-photo:before {
  content: "\\e807";
} /* '' */
.icon-down-arrow:before {
  content: "\\e808";
} /* '' */
.icon-search:before {
  content: "\\e809";
} /* '' */
.icon-right-arrow:before {
  content: "\\e80a";
} /* '' */
.icon-song:before {
  content: "\\e80b";
} /* '' */
.icon-top-arrow:before {
  content: "\\e80c";
} /* '' */`, "",{"version":3,"sources":["webpack://./src/zintunes-icons/css/zintunes.css"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,uBAAA;EACA,4CAAA;EACA,4SAAA;EAKA,mBAAA;EACA,kBAAA;AAFF;AAIA,gGAAA;AACA,2FAAA;AACA;;;;;;;CAAA;AAQA;EACE,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EAEA,qBAAA;EACA,wBAAA;EACA,UAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;EAEA,gEAAA;EACA,6BAAA;EAAA,oBAAA;EACA,oBAAA;EAEA,8CAAA;EACA,gBAAA;EAEA,gEAAA;EACA,yBAAA;EACA,kBAAA;EAEA,0DAAA;EACA,qBAAA;EAEA,6CAAA;EACA,mCAAA;EACA,kCAAA;EAEA,4BAAA;EACA,uDAAA;AATF;;AAYA;EAAqB,gBAAA;AARrB,EAQyC,QAAA;AACzC;EAAsB,gBAAA;AANtB,EAM0C,QAAA;AAC1C;EAA0B,gBAAA;AAJ1B,EAI8C,QAAA;AAC9C;EAA4B,gBAAA;AAF5B,EAEgD,QAAA;AAChD;EAAqB,gBAAA;AAArB,EAAyC,QAAA;AACzC;EAAqB,gBAAA;AAErB,EAFyC,QAAA;AACzC;EAAsB,gBAAA;AAItB,EAJ0C,QAAA;AAC1C;EAAqB,gBAAA;AAMrB,EANyC,QAAA;AACzC;EAA0B,gBAAA;AAQ1B,EAR8C,QAAA;AAC9C;EAAsB,gBAAA;AAUtB,EAV0C,QAAA;AAC1C;EAA2B,gBAAA;AAY3B,EAZ+C,QAAA;AAC/C;EAAoB,gBAAA;AAcpB,EAdwC,QAAA;AACxC;EAAyB,gBAAA;AAgBzB,EAhB6C,QAAA","sourcesContent":["@font-face {\r\n  font-family: 'zintunes';\r\n  src: url('../font/zintunes.eot?64742434');\r\n  src: url('../font/zintunes.eot?64742434#iefix') format('embedded-opentype'),\r\n       url('../font/zintunes.woff2?64742434') format('woff2'),\r\n       url('../font/zintunes.woff?64742434') format('woff'),\r\n       url('../font/zintunes.ttf?64742434') format('truetype'),\r\n       url('../font/zintunes.svg?64742434#zintunes') format('svg');\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n/* Chrome hack: SVG is rendered more smooth in Windozze. 100% magic, uncomment if you need it. */\r\n/* Note, that will break hinting! In other OS-es font will be not as sharp as it could be */\r\n/*\r\n@media screen and (-webkit-min-device-pixel-ratio:0) {\r\n  @font-face {\r\n    font-family: 'zintunes';\r\n    src: url('../font/zintunes.svg?64742434#zintunes') format('svg');\r\n  }\r\n}\r\n*/\r\n[class^=\"icon-\"]:before, [class*=\" icon-\"]:before {\r\n  font-family: \"zintunes\";\r\n  font-style: normal;\r\n  font-weight: normal;\r\n  speak: never;\r\n\r\n  display: inline-block;\r\n  text-decoration: inherit;\r\n  width: 1em;\r\n  margin-right: .2em;\r\n  text-align: center;\r\n  /* opacity: .8; */\r\n\r\n  /* For safety - reset parent styles, that can break glyph codes*/\r\n  font-variant: normal;\r\n  text-transform: none;\r\n\r\n  /* fix buttons height, for twitter bootstrap */\r\n  line-height: 1em;\r\n\r\n  /* Animation center compensation - margins should be symmetric */\r\n  /* remove if not needed */\r\n  margin-left: .2em;\r\n\r\n  /* you can be more comfortable with increased icons size */\r\n  /* font-size: 120%; */\r\n\r\n  /* Font smoothing. That was taken from TWBS */\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n\r\n  /* Uncomment for 3D effect */\r\n  /* text-shadow: 1px 1px 1px rgba(127, 127, 127, 0.3); */\r\n}\r\n\r\n.icon-album:before { content: '\\e800'; } /* '' */\r\n.icon-anchor:before { content: '\\e801'; } /* '' */\r\n.icon-caret-down:before { content: '\\e802'; } /* '' */\r\n.icon-check-circle:before { content: '\\e803'; } /* '' */\r\n.icon-check:before { content: '\\e804'; } /* '' */\r\n.icon-close:before { content: '\\e805'; } /* '' */\r\n.icon-delete:before { content: '\\e806'; } /* '' */\r\n.icon-photo:before { content: '\\e807'; } /* '' */\r\n.icon-down-arrow:before { content: '\\e808'; } /* '' */\r\n.icon-search:before { content: '\\e809'; } /* '' */\r\n.icon-right-arrow:before { content: '\\e80a'; } /* '' */\r\n.icon-song:before { content: '\\e80b'; } /* '' */\r\n.icon-top-arrow:before { content: '\\e80c'; } /* '' */\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
